import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { GetTemplatesResponse } from 'lib/api/integrations/digitalSignature';
import { User } from 'lib/types/models';
import React, { useMemo } from 'react';

import OperationAssociation from '../../OperationAssociation';
import { OperationAssociationValue } from '../../OperationAssociation/operations';
import TemplateSelector from './TemplateSelector';

interface Props {
  templates: GetTemplatesResponse[];
  selectedTemplate: string | undefined;
  title: string | undefined;
  setTitle: (title: string) => void;
  template: string | undefined;
  setTemplate: (template: string) => void;
  operation: OperationAssociationValue;
  setOperation: (operation: OperationAssociationValue) => void;
  businessIdentifier: string | undefined;
  businessUsers: User[];
  businessUserIds: number[];
  setBusinessUserIds: (businessUserIds: number[]) => void;
}

const Template = ({
  templates,
  selectedTemplate,
  title,
  setTitle,
  template,
  setTemplate,
  operation,
  setOperation,
  businessIdentifier,
  businessUsers,
  businessUserIds,
  setBusinessUserIds,
}: Props) => {
  const templateType = useMemo(() => {
    return templates.find((t) => t.id === template)?.type;
  }, [template, templates]);
  const signers = useMemo(() => {
    return templates.find((t) => t.id === template)?.signers ?? [];
  }, [template, templates]);

  const handleSetTemplate = (template: string) => {
    setTemplate(template);
    const type = templates.find((t) => t.id === template)?.type;
    if (type === 'warranty-request')
      setOperation({
        enabled: true,
        operationType: 'warranty-request',
        operation: undefined,
      });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <FormControl fullWidth margin="dense">
          <InputLabel id="template-label">
            {templates.length === 0 ? 'No existen plantillas' : 'Plantilla'}
          </InputLabel>
          <Select
            labelId="template-label"
            label="Plantilla"
            value={template}
            onChange={(e) => handleSetTemplate(e.target.value)}
            disabled={templates.length === 0}
            error={templates.length === 0}
          >
            {templates.map((templateItem) => (
              <MenuItem key={templateItem.id} value={templateItem.id}>
                {templateItem.description || 'Sin descripción'}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {template && (
          <TextField
            fullWidth
            margin="dense"
            label="Título del portafolio"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Ingrese el título del portafolio"
          />
        )}
        {template && templateType === 'warranty-request' && (
          <OperationAssociation
            value={operation}
            onChange={setOperation}
            businessIdentifier={businessIdentifier}
          />
        )}
        {template && templateType === 'pep' && (
          <FormControl fullWidth margin="dense">
            <InputLabel id="pep-signer-label">Firmante</InputLabel>
            <Select
              labelId="pep-signer-label"
              label="Firmante"
              value={businessUserIds[0] ?? ''}
              onChange={(e) => setBusinessUserIds([Number(e.target.value)])}
            >
              {businessUsers.map((user) => (
                <MenuItem key={user.id} value={user.id}>
                  {user.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Grid>
      <Grid item xs={6}>
        <TemplateSelector
          templates={templates}
          selectedTemplate={selectedTemplate}
          signers={signers}
        />
      </Grid>
    </Grid>
  );
};

export default Template;
